import * as Joi from 'joi';

import {
  TEAM_NAME_VALIDATOR,
  PROJECT_NAME_JOI_VALIDATOR_MESSAGES,
  ORGANIZATION_DISPLAY_NAME_VALIDATOR,
  ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES,
  ORGANIZATION_NAME_VALIDATOR,
  ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES,
} from '../validation';

export const createTeamValidation = Joi.object({
  name: Joi.string()
    .pattern(TEAM_NAME_VALIDATOR.pattern.value)
    .min(TEAM_NAME_VALIDATOR.minLength.value)
    .max(TEAM_NAME_VALIDATOR.maxLength.value)
    .required()
    .messages(PROJECT_NAME_JOI_VALIDATOR_MESSAGES),
});

const displayNameValidation = Joi.string()
  .max(ORGANIZATION_DISPLAY_NAME_VALIDATOR.maxLength.value)
  .min(ORGANIZATION_DISPLAY_NAME_VALIDATOR.minLength.value)
  .pattern(ORGANIZATION_DISPLAY_NAME_VALIDATOR.pattern.value)
  .required()
  .messages(ORGANIZATION_DISPLAY_NAME_JOI_VALIDATOR_MESSAGES);

const nameValidation = Joi.string()
  .max(ORGANIZATION_NAME_VALIDATOR.maxLength.value)
  .min(ORGANIZATION_NAME_VALIDATOR.minLength.value)
  .pattern(ORGANIZATION_NAME_VALIDATOR.pattern.value)
  .required()
  .messages(ORGANIZATION_NAME_JOI_VALIDATOR_MESSAGES);

export const createOrganization = Joi.object({
  name: nameValidation,
  displayName: displayNameValidation,
  acceptedBy: Joi.string().required(),
}).required();
